module.exports = __webpack_public_path__ + "static/pic01-707a941eead2aaab1bf2a12ae4b1f64d.jpg";